(function (window, document) {
    'use strict';

    var measurementId = window.BMHAnalyticsId;
    var loaded = false;
    var consentKey = 'bmh_analytics_consent';

    if (!measurementId || navigator.doNotTrack === '1') {
        return;
    }

    function consentDenied() {
        try {
            return window.localStorage.getItem(consentKey) === 'denied';
        } catch (error) {
            return false;
        }
    }

    function loadAnalytics() {
        if (loaded || consentDenied()) {
            return;
        }
        loaded = true;
        window.dataLayer = window.dataLayer || [];
        window.gtag = window.gtag || function () {
            window.dataLayer.push(arguments);
        };
        window.gtag('js', new Date());
        window.gtag('config', measurementId);
        var script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(measurementId);
        document.head.appendChild(script);
    }

    function scheduleAfterLcp() {
        var schedule = window.requestIdleCallback || function (callback) {
            return window.setTimeout(callback, 2000);
        };
        schedule(loadAnalytics, { timeout: 4000 });
    }

    ['pointerdown', 'keydown', 'touchstart'].forEach(function (eventName) {
        window.addEventListener(eventName, loadAnalytics, { once: true, passive: true });
    });

    window.addEventListener('bmh:analytics-consent', function (event) {
        if (event.detail === 'granted') {
            loadAnalytics();
        }
    }, { passive: true });

    window.addEventListener('load', scheduleAfterLcp, { once: true, passive: true });
})(window, document);
